"use client";

import { useLayoutEffect } from "react";
import { getMediaType } from "@/util/media";
import { SectionsDocumentationHeader, SectionProps } from "@/types";

import {
  documentationHeaderVariant,
  type DocumentationHeaderVariantProps,
} from "./documentation-header.variants";

export type UseDocumentationHeaderProps = DocumentationHeaderVariantProps &
  SectionProps<SectionsDocumentationHeader>;

export const useDocumentationHeader = (props: UseDocumentationHeaderProps) => {
  const {
    data: { media, htmlId, ...restData },
    sectionName,
  } = props;

  const styles = documentationHeaderVariant();

  const isVideoBackground = !!media && getMediaType(media?.url) === "video";

  useLayoutEffect(() => {
    setTimeout(() => {
      scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 500);
  }, []);

  return {
    styles,
    data: { media, ...restData },
    sectionName,
    isVideoBackground,
    componentProps: {
      id: htmlId,
      className: styles.base({ className: sectionName }),
    },
  };
};
